export { CollectiblesProductCarouselItem } from './CollectibleProductCarouselItem'
